import * as Yup from 'yup';
import { validateDate, validateFloat, validateLeaseType, validateNumericId, validateOptionalLeaseOptions } from "@/Shared/Helpers";
import { LeaseEnums } from '@/Shared';

export interface LeaseFormValues {
    leaseType?: string | null;
    leaseStart?: string | null;
    leaseEnd?: string | null;

    revisionRate?: number | null;
    revisionFrequency?: string | null;

    activity?: string | null;
    usageDescription?: string | null;

    leaseOptions?: string[];

    tenants?: number[];
    transactionId?: number | null;
}

export const LeaseValidationSchema = (viewEnums : LeaseEnums) => Yup.object({
    leaseType: validateLeaseType(viewEnums.LeaseTypeEnum),
    leaseOptions: validateOptionalLeaseOptions(viewEnums.LeaseOptionEnum),

    leaseStart: validateDate().nullable(),
    leaseEnd: validateDate().nullable(),

    revisionRate: validateFloat().nullable(),
    revisionFrequency: Yup.string().max(20, 'La fréquence de révision ne peut pas dépasser 20 caractères.').nullable(),

    activity: Yup.string().max(255, 'L\'activité ne peut pas dépasser 255 caractères.').nullable(),
    usageDescription: Yup.string().max(255, 'La description d\'usage ne peut pas dépasser 255 caractères.').nullable(),


    transactionId: validateNumericId().required('La transaction est requise.'),
});
